export const API_BASE_URL = `https://api.usam.co.in/ibs`;
export const SOCKET_BASE_URL = `https://api.usam.co.in`;
// export const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/ibs`;
// export const SOCKET_BASE_URL = "https://crm.usam.co.in";

export const GOOGLE_MAPS_API_KEY = "AIzaSyBQ2U1B3EsX27PrBbX8J4-J38NCd-2uX_8"; // Added By Jaseem Google Map Key (Date => 18-05-2026).

// export const API_BASE_URL= "https://spark.indicrm.io/ibs";
//export const SOCKET_BASE_URL = "https://spark.indicrm.io";
export const VIEW_LEAD = "VIEW_LEAD";
export const VIEW_PROPERTY = "VIEW_PROPERTY";
export const EDIT_LEAD = "EDIT_LEAD";
export const DELETE_LEAD = "DELETE_LEAD";
export const VIEW_PRODUCT = "VIEW_PRODUCT";
export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const MODIFY_ALL = "MODIFY_ALL";
export const VIEW_ALL = "VIEW_ALL";
export const VIEW_ORDER = "VIEW_ORDER";
export const VIEW_USER = "VIEW_USER";
export const VIEW_CONTACT = "VIEW_CONTACT";
export const EDIT_CONTACT = "EDIT_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const VIEW_ACCOUNT = "VIEW_ACCOUNT";
export const EDIT_ACCOUNT = "EDIT_ACCOUNT";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const VIEW_BUSINESS = "VIEW_BUSINESS";
export const EDIT_BUSINESS = "EDIT_BUSINESS";
export const DELETE_BUSINESS = "DELETE_BUSINESS";
export const VIEW_INCIDENT = "VIEW_INCIDENT";

//FILE TYPES
export const PDF = "pdf";
export const DOC = "doc";
export const DOCX = "docx";
export const XLS = "xls";
export const XLSX = "xlsx";
export const CSV = "csv";
export const PNG = "png";
export const JPG = "jpg";
export const JPEG = "jpeg";

// export const LEAD_STATUS_VALUES = [{label : 'Open - Not Contacted', islast : false}, {label : 'Working Contacted', islast : false} , {label : 'Closed - Converted', islast : true}, {label : 'Closed - Not Converted', islast : true}];
export const LEAD_STATUS_VALUES =
    [
        {
            label: "Open - Not Contacted",
            sortorder: 1,
            is_converted: false,
            is_lost: false,
        },
        {
            label: "Working - Contacted",
            sortorder: 2,
            is_converted: false,
            is_lost: false,
        },
        {
            label: "Closed - Converted",
            sortorder: 3,
            is_converted: true,
            is_lost: false,
        },
        {
            label: "Closed - Not Converted",
            sortorder: 4,
            is_converted: false,
            is_lost: true,
        },
        
    ];
    export const Product_CATEGORY_VALUES =
    [ 
        {
            label: "HOME AUTOMATION SOLUTIONS",
            sortorder: 1,
           is_converted: false,
           is_lost: false,
        },
        {
            label: "HOME THEATER",
            sortorder: 2,
           is_converted: false,
           is_lost: false,
        },
        {
            label: "RECLINERS",
            sortorder: 2,
           is_converted: false,
           is_lost: false,
        },
        {
            label: "ENGINEERED WOODEN FLOORINGS",
            sortorder: 2,
           is_converted: false,
           is_lost: false,
        },
        {
            label: "LUXURY BATHING SOLUTIONS",
            sortorder: 2,
           is_converted: false,
           is_lost: false,
        },
        {
            label: "UPVC DOORS & WINDOWS(OYSTER)",
            sortorder: 2,
           is_converted: false,
           is_lost: false,
        },
        {
            label: "LANDSCAPE SOLUTIONS",
            sortorder: 2,
           is_converted: false,
           is_lost: false,
        },
        {
            label: "OTHERS",
            sortorder: 2,
           is_converted: false,
           is_lost: false,
        },
    ];

    export const Product_SUBCATEGORY_VALUES = 
    [
        {
            label: "Subscription",
            sortorder: 1,
        },
        {
            label: "Insurance",
            sortorder: 2,
        },
        {
            label: "Implementation",
            sortorder: 2,
        },
        {
            label: "Goods",
            sortorder: 2,
        },
        {
            label: "Material",
            sortorder: 2,
        },
        {
            label: "Fashion",
            sortorder: 2,
        },
        {
            label: "Others",
            sortorder: 2,
        }
        
    ];

    export const LEAD_TYPE = 
    [
        {
            label: "Hot",
            value: "Hot",
            sortorder: 1,
        },
        {
            label: "Cold",
            value: "Cold",
            sortorder: 2,
        },
        {
            label: "Warm",
            value: "Warm",
            sortorder: 2,
        },
        
    ];
    // Not Interested 